import React from "react";

const AboutUsUserCard = ({ className, username, position, userProfilePic }) => {
  return (
    <div
      className={`flex flex-row items-center justify-center space-x-4 ${className}`}
    >
      <img
        alt="User Profile"
        src={userProfilePic}
        className="w-11 md:w-16 h-11 md:h-16 flex items-center justify-center rounded-full bg-black object-center object-cover grayscale"
      />
      <div className="flex flex-col items-start text-white">
        <p className="text-lg font-bold leading-snug items-center text-center tracking-normal ">
          {username}
        </p>
        <p className="text-base leading-snug items-center text-center tracking-normal ">
          {position}
        </p>
      </div>
    </div>
  );
};

export default AboutUsUserCard;
